import { styled } from "@linaria/react";
import React from "react";
import { color, fonts, radius, zIndex } from "..";
import { shadows } from "../Theme";
import Popper, { type PopperProps } from "../Popper";

const UnstyledTooltip = (props: PopperProps) => (
  <Popper
    hover
    keepOpenOnOverlayActive
    gap={5}
    arrowWidth={8}
    openDelay={200}
    closeDelay={300}
    placement="top"
    borderWidth={1}
    borderColor={color.darkNitrogen900}
    backgroundColor={color.darkNitrogen900}
    color={color.hydrogen}
    {...props}
  />
);

/**
  Usage:
  Should only be used with the Tooltip wrapper component which hosts now the paddings and the internal placement of the elements.
  Wrapper accepts a title, a description and a link as props, all optional. The link.value can be to classic 'to' of react-router NavLinks or the ref to a classic <a> tag.

  <Tooltip 
    overlay={
      <OverlayWrapper
        title="tooltip title"
        text="tooltip text"
        link={{
          label: "tooltip link label",
          value: "https://www.metroscope.tech/",
          type: LinkType.INTERNAL_LINK || LinkType.EXTERNAL_LINK, // default is INTERNAL_LINK for react-router navlinks
        }}
      />
  >

  If you only need a simple text, use the text prop of the wrapper as :
  <Tooltip 
    overlay={
      <OverlayWrapper
        text="tooltip text"
      />
  >

*/
const Tooltip = styled(UnstyledTooltip)`
  max-width: 500px;
  padding: 10px;
  font: ${fonts.body2};
  font-weight: 500;
  z-index: ${zIndex.popper};
  border-radius: ${radius};
  box-shadow: ${shadows.shadow100};
`;

export default React.memo(Tooltip);
